import React, {ChangeEvent, useCallback, useEffect} from 'react';
import DocumentTitle from 'react-document-title';

import {useUserEmail} from 'src/hooks/useUserEmail';
import {getUserSettings} from 'src/modules/user-settings/services/selectors';
import {UserSettingsView} from 'src/modules/user-settings/user-settings.view';
import {getUserSettingsByEmail, saveUserSettings} from 'src/openapi/apis/UserControllerApi';
import {UserSettings} from 'src/openapi/models/UserSettings';
import {useAppDispatch, useAppSelector} from 'src/store';

export const UserSettingsController = () => {
    const userEmail = useUserEmail();
    const dispatch = useAppDispatch();
    const userSettings = useAppSelector(getUserSettings);

    useEffect(() => {
        dispatch(getUserSettingsByEmail({email: userEmail}));
    }, [dispatch, userEmail]);

    const save = useCallback((settings: UserSettings) => {
        dispatch(saveUserSettings({userSettings: settings}));
    }, [dispatch]);

    const onCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (userSettings) {
            const {checked, name} = event.target;
            save({...userSettings, [name]: checked});
        }
    };

    return (
        <>
            <DocumentTitle title="User Settings"/>
            <UserSettingsView
                userSettings={userSettings}
                onChange={onCheckboxChange}
            />
        </>
    );
};
